import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../../environments/environment.prod';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../components/Authentication/services/authentication.service';
import { CommonModule } from '@angular/common';
import { ConnectiveservicesService } from '../../Services/Apis/Connectiveservices/connectiveservices.service';
import { ThemeService } from '../../Services/themes.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import i18next from 'i18next';
import { TranslateDirective } from '../../components/Utilites/Directives/translate.directive';
import { Store } from '@ngrx/store';
import { ApiservicesService } from '../../Services/Apis/apiservices.service';
import { allEmployeeFields } from '../../ngrxState/actions';

@Component({
  selector: 'app-header',
  imports: [
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    CommonModule,
    MatExpansionModule,
    MatSlideToggleModule,
    TranslateDirective,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  styles: [
    `
      .spacer {
        flex: 1 1 auto;
      }

      .title {
        cursor: pointer;
      }

      .welcome-text {
        font-size: smaller;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  @Output() menuToggled = new EventEmitter<boolean>();

  user: string = 'user';
  userdata: any;
  selected_sub_org: any;
  assetUrl: string = environment.ASSET_URL;
  assetContainer: string = environment.ASSET_CONTAINER;
  // constructor(private authService: AuthService) { }
  isDarkMode = false;
  selectedTheme: any;
  selectedlang: any;
  accessUrl = environment.ASSET_URL;
  containerName = environment.ASSET_CONTAINER;
  base_url = this.accessUrl.split('.net/')[0] + '.net/';

  constructor(
    private authservice: AuthenticationService,
    private connectiveservice: ConnectiveservicesService,
    private router: Router,
    private themeService: ThemeService,
    private store: Store,
    private apiservice: ApiservicesService,
  ) {
    if (this.authservice.user) {
      this.authservice.user.subscribe((x) => {
        this.userdata = JSON.parse(x);
      });
    }
  }

  ngOnInit(): void {
    this.selected_sub_org =
      this.connectiveservice.get_selected_sub_organization();
    this.user = this.userdata?.data.first_name;
    this.selectedTheme = sessionStorage.getItem('theme');
    this.selectedlang = i18next.language || 'en';
    this.apiservice.getOrganizationforms({}).subscribe((res: any) => {
      fetch(this.base_url + this.containerName + '/' + res.rows[0].file_url)
        .then((response) => response.json())
        .then((data) => {
          this.store.dispatch(allEmployeeFields({ allEmployeeFields: data }));
        })
        .catch((error) => console.error(error));
    });
  }

  logout() {
    this.authservice.logout();
  }

  Storesuborgdata(suborg: any) {
    this.selected_sub_org = suborg;
    sessionStorage.setItem('SubOrgData', JSON.stringify(suborg));
    // this.router.navigate(['/onboarding']);
    if (
      this.selected_sub_org.onboarding_status == false ||
      this.selected_sub_org.onboarding_status == 0
    ) {
      this.router.navigate(['/onboarding']);
    } else {
      // this.router.navigate(['/dashboard']);
      this.gotoprofile();
    }
    setTimeout(() => window.location.reload(), 1000);
  }
  gotoprofile() {
    if (this.userdata?.data?.user_role === 'STUDENTS') {
      this.router.navigate(['studentview'], {
        queryParams: { dataId: this.userdata?.data?.id },
      });
    } else {
      this.router.navigate(['/employeeview'], {
        queryParams: { dataId: this.userdata?.data?.id },
      });
    }
  }

  changeTheme(event: Event): void {
    const theme = (event.target as HTMLSelectElement).value as
      | 'dark-theme'
      | 'custom-theme'
      | 'default';
    sessionStorage.setItem('theme', theme);
    this.themeService.setTheme(theme);
  }

  switchLang(lang: string) {
    i18next.changeLanguage(lang);
    location.reload(); // optional to refresh directive text
  }
}
